import { render } from "./PersonalitiesSignificantResearch.vue?vue&type=template&id=40465cc6"
import script from "./PersonalitiesSignificantResearch.vue?vue&type=script&lang=js"
export * from "./PersonalitiesSignificantResearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__